import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25,0 C40.29352,0 49.8083704,12.702096 49.9971381,24.6365973 L50,24.998 C50,38.77 38.77,50 25,50 C11.23,50 0,38.77 0,25 C0,11.23 11.23,0 25,0 Z M25,3 C12.88,3 3,12.88 3,25 C3,37.12 12.88,47 25,47 C36.9988,47 46.802176,37.316612 46.9970436,25.3629204 L47,24.998 C47,14.402 38.594,3 25,3 Z M33.23,17.074 L35.722,19.564 L21.188,34.198 L14.228,27.238 L16.718,24.746 L21.138,29.168 L33.23,17.074 Z"
  })]
});